import { EXTERNAL_URL } from 'src/shared/config/src';
import { useNavigate } from 'react-router-dom';
import { usePreviousRoute } from 'src/app/guards/PreviousRouteContext';
import { AppRoutes } from 'src/app/navigation/routes';
import LocalImages from 'src/app/static';
import { appStoreLink, playStoreLink } from 'src/app/config/appConstants';
import { BsArrowRight } from 'react-icons/bs';
import { Footer } from 'src/app/components';

const NewDownloadAppScreen = () => {

    const navigate = useNavigate();
    const { clearPreviousRoute} = usePreviousRoute();

    const continueOnWebClick = () => {
        clearPreviousRoute();
        navigate(AppRoutes.VERIFY_EMAIL, {replace: true});
    }
    
    return (
        <div className={`main-wrapper bg-white container`}>
            <div className='download-app-wrapper-layout'>
                <div className='download-app-content-layout'>
                    <div>
                        <div className='logo'><img src={LocalImages.logo} alt="logo" /></div>
                        <div className='download-app'>
                            <img alt="download-app" src={LocalImages.downloadAppImg} className="img-fluid" />
                        </div>
                        <div className='app-download'>
                            <p className='app-download-text text-black mg-b-0'>Download our app for a smoother and more intuitive experience tailored just for you.</p>
                            <div className='icons-app'>
                                <div className='d-flex align-items-center mx-n-8'>
                                    <a href={playStoreLink} target='_blank' rel='noreferrer' className='w-50 pd-x-8'><img src={LocalImages.googlePlay} alt="google-play" className='w-100' /></a>
                                    <a href={appStoreLink} target='_blank' rel='noreferrer' className='w-50 pd-x-8'><img src={LocalImages.appleStore} alt="apple-store" className='w-100' /></a>
                                </div>
                            </div>
                        </div>
                        <div className='or-text'><span>OR</span></div>
                        <div className='continue-on-web'>
                            <button className='btn btn-link' onClick={continueOnWebClick}>
                                Continue on Web <BsArrowRight size={20} />
                            </button>
                        </div>
                    </div>
                </div>

                <div className='mt-auto'>
                    <Footer />
                </div>
            </div>
        </div>
    )
};

export default NewDownloadAppScreen;